var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .8 0 27.184)",
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18.5,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 63.5,
    width: 16,
    height: 10,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -.8 0 100.82 106.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18.5,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 63.5,
    width: 16,
    height: 10,
    ry: 2
  })), /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18.5,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 63.5,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -.8 0 100.82 -33.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18.5,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 16,
    height: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 63.5,
    width: 16,
    height: 10,
    ry: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: -17.5,
    width: 100,
    height: 126,
    ry: 3.8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3 61.1C81.1 70.4 73.1 76.6 64 76.6c-13.5 0-24.5-13.7-24.5-30.6s11-30.6 24.5-30.6c9.1 0 17.1 6.3 21.3 15.6l13-9.4C91.5 6.7 78.7-3.4 64-3.4 42.2-3.4 24.5 18.7 24.5 46S42.2 95.4 64 95.4c14.6 0 27.4-10 34.2-24.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: -5.2,
    rx: 3,
    ry: 3.8,
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.b0a9bd3477af216c04fa7a705c08f8f5.svg";
export { ForwardRef as ReactComponent };